module.exports = __webpack_public_path__ + "img/circle.dc96963b.png";